/* Only hide the dock for a real editable field; no scroll-driven animation. */
(() => {
  const mobile = window.matchMedia('(max-width: 767px)');
  function update() {
    const field = document.activeElement;
    const editing = field && field.matches('textarea, [contenteditable="true"], input:not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]):not([type="range"]):not([type="hidden"])');
    document.body.classList.toggle('mobile-keyboard-open', mobile.matches && !!editing);
  }
  document.addEventListener('focusin', update);
  document.addEventListener('focusout', () => requestAnimationFrame(update));
  mobile.addEventListener('change', update);
})();
